const my = {
  email: {
    required: 'Sila masukkan emel anda',
    valid: 'Alamat emel tidak sah',
  },
  password: {
    required: 'Sila masukkan kata laluan anda',
    min: 'Perlu lebih daripada 6 aksara',
  },
  addressRequired: 'Please input store address',
  storeNameRequired: 'Please input store name',
  miniumAmountRequired: 'Please input your minimum amount required',
  latitudeRequired: 'Please input latitude',
  longitudeRequired: 'Please input longitude',
  workingTimeInvalid: 'Masa buka mesti sebelum masa tutup',
  digit: 'Sila masukkan nombor sahaja',
  updateSettingsFailed: 'Gagal mengemas kini tetapan',
  emptyRequestHelp: 'Please enter something',

  INVALID_EMAIL: 'Alamat emel tidak sah',
  INVALID_EMAIL_OR_PASSWORD: 'Alamat emel atau kata laluan tidak sah',
  INVALID_VERIFY_CODE: 'Kod penentusahan tidak sah',
  CAN_NOT_FIND_STORE: 'Lokasi tidak dapat dikesan',
  PLEASE_INPUT_CORRECT_DATA: 'Sila masukkan data yang betul',
};

export default my;
